import AdminSidebarNav from "@admin/components/AdminSidebarNav";
import AdminModal from "@admin/components/modal/AdminModal";
import { Navigate, Outlet } from "react-router-dom";

import { isAdminAuthenticated } from "@/libs/auth";

export default function AuthLayout() {
  if (!isAdminAuthenticated()) {
    return <Navigate to="/login" replace />;
  }

  return (
    <>
      <AdminModal />
      {/* 뷰포트 높이 고정 flex 셸 — 사이드바 고정 + 컨텐츠 영역만 스크롤.
          하위 페이지가 h-full/flex-1로 정확히 채울 수 있게 함(100vh-Npx 하드코딩 제거). */}
      <div className="flex h-screen">
        <AdminSidebarNav />
        <div className="min-w-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    </>
  );
}
